import { moteRecorderErrorMap } from '@mote/helpers/hooks/recorder/errors'
import { AskForMicrophonePermissionError } from './AskForMicrophonePermissionError'
import { ChunksErrorThresholdError } from './ChunksErrorThresholdError'
import { FixMicrophonePermissionError } from './FixMicrophonePermissionError'
import { ForceUpgradeError } from './ForceUpgradeError'
import { MoteIdUndefinedError } from './MoteIdUndefinedError'
import { NetworkError } from './NetworkError'
import { NotLoggedInError } from './NotLoggedInError'
import { PollingThresholdExceededError } from './PollingThresholdExceededError'
import { QuotaExceededError } from './QuotaExceededError'
import { UnknownError } from './UnknownError'

export interface CommonRecordingErrorProps<T extends string> {
  type: T
  onMount?: () => void
  onClose: () => void
}

interface QuotaExceededRecordingErrorProps
  extends CommonRecordingErrorProps<
    typeof moteRecorderErrorMap.QUOTA_EXCEEDED
  > {
  nextFreeBatchDate: number
  isMinor: boolean
}

export type RecordingErrorProps =
  | CommonRecordingErrorProps<typeof moteRecorderErrorMap.NOT_LOGGED_IN>
  | CommonRecordingErrorProps<
      typeof moteRecorderErrorMap.ASK_FOR_MICROPHONE_PERMISSION
    >
  | CommonRecordingErrorProps<
      typeof moteRecorderErrorMap.FIX_MICROPHONE_PERMISSION
    >
  | CommonRecordingErrorProps<typeof moteRecorderErrorMap.FORCE_UPGRADE>
  | CommonRecordingErrorProps<typeof moteRecorderErrorMap.UNKNOWN_ERROR>
  | CommonRecordingErrorProps<
      typeof moteRecorderErrorMap.CHUNKS_ERROR_THRESHOLD_ERROR
    >
  | CommonRecordingErrorProps<typeof moteRecorderErrorMap.NETWORK_ERROR>
  | CommonRecordingErrorProps<
      typeof moteRecorderErrorMap.MOTE_ID_UNDEFINED_ERROR
    >
  | CommonRecordingErrorProps<
      typeof moteRecorderErrorMap.POLLING_THRESHOLD_EXCEEDED
    >
  | QuotaExceededRecordingErrorProps

export function RecordingError(props: RecordingErrorProps) {
  switch (props.type) {
    case moteRecorderErrorMap.NOT_LOGGED_IN:
      return (
        <NotLoggedInError onMount={props.onMount} onClose={props.onClose} />
      )
    case moteRecorderErrorMap.FORCE_UPGRADE:
      return <ForceUpgradeError onClose={props.onClose} />
    case moteRecorderErrorMap.QUOTA_EXCEEDED:
      return (
        <QuotaExceededError
          onClose={props.onClose}
          nextFreeBatchDate={props.nextFreeBatchDate}
          isMinor={props.isMinor}
        />
      )
    case moteRecorderErrorMap.UNKNOWN_ERROR:
      return <UnknownError onClose={props.onClose} />
    case moteRecorderErrorMap.CHUNKS_ERROR_THRESHOLD_ERROR:
      return <ChunksErrorThresholdError onClose={props.onClose} />
    case moteRecorderErrorMap.POLLING_THRESHOLD_EXCEEDED:
      return <PollingThresholdExceededError onClose={props.onClose} />
    case moteRecorderErrorMap.NETWORK_ERROR:
      return <NetworkError onClose={props.onClose} />
    case moteRecorderErrorMap.MOTE_ID_UNDEFINED_ERROR:
      return <MoteIdUndefinedError onClose={props.onClose} />
    case moteRecorderErrorMap.ASK_FOR_MICROPHONE_PERMISSION:
      return <AskForMicrophonePermissionError onClose={props.onClose} />
    case moteRecorderErrorMap.FIX_MICROPHONE_PERMISSION:
      return <FixMicrophonePermissionError onClose={props.onClose} />
    default:
      return <></>
  }
}
